import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=12ba0822&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=12ba0822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba0822",
  null
  
)

export default component.exports